export const blockIconsBusinessandpaymentsCurrencyExchangeNew = (
	<span className='material-symbols-outlined'>currency_exchange</span>
);
